<template>
  <div class="navigation-container">
    <div v-show="!isSoftwareBrand" class="navigation-arrow" @click="handleBack"></div>
    <div class="navigation-title">{{ title }}</div>
  </div>
</template>

<script>
export default _extend({
  name: 'Navigation',
  data() {
    return {
      isSoftwareBrand: false
    };
  },
  props: {
    showArrow: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    onBack: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    handleBack() {
      this.onBack && this.onBack();
    },
    getQueryString(name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      };
      return null;
    }
  },
  created() {
    // console.log('location');
    const softwareBrand = this.getQueryString('softwareBrand');
    if (softwareBrand && softwareBrand.toLocaleLowerCase() === 'goodview') {
      this.isSoftwareBrand = true;
    } else {
      this.isSoftwareBrand = false;
    }
  }
});
</script>

<style lang="scss" scoped>
@import './Navigation.scss';
</style>



// WEBPACK FOOTER //
// src/components/NewComponents/Navigation/Navigation.vue